import React, { useState, useEffect } from "react";
import { withRouter } from "../_shared/withRouter";
import { useTranslation } from "react-i18next";
import Header from "../template/_common/header";
import SidebarComponent from "../template/admin/sidebarComponent";
import VideoTable from "../template/admin/videoTable";
import SidebarArrow from "../template/_common/sidebarArrow";
import { globalAlert, globalLoader } from "../actions/commonActions";
import AddVideoModal from "../template/admin/addVideoModal";
import {
  getVideoListApi,
  addVideoApi,
  deleteVideoApi,
  toggleVideoApi,
} from "./_actions";
import ConfirmationModal from "../template/_common/confirmModal";
import PaginationOwn from "../template/_common/ownPagination";
import { compareValues, logOut } from "../_shared/commonFunction";
import VideoModal from "../template/admin/videoModal";
import { Helmet } from "react-helmet";
import InputComponent from "../template/_common/inputComponent";
import arraySort from 'array-sort';


const ManageVideos = (props) => {
  const { t } = useTranslation();
  const [navbarToggle, setNavbarToggle] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [currentData, setCurrentData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [editDataIs, setEditDataIs] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [confirmaModalOpen, setConfirmaModalOpen] = useState(false);
  const [pageSize, setPageSize] = useState(25);
  const [searchVal, setSearchVal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentDataList, setCurrentDataList] = useState([]);
  const [sortObj, setSortObj] = useState({});
  const [currentDataSorted, setCurrentDataSorted] = useState([]);
  const [notFilteredRun, setNotFilteredRun] = useState(false);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  const [currentVideoSrc, setCurrentVideoSrc] = useState(null);
  const [totalCount, setTotalCount] = useState(null);
  const [allowView, setAllowView] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);

  const handleSidebar = (data) => {
    setNavbarToggle(data);
  };

  useEffect(() => {
    callBasicApi(); // eslint-disable-next-line
  }, []);

  const callBasicApi = async () => {
    try {
      globalLoader(true);
      let res = await getVideoListApi();
      if (res?.data?.status === 200) {
        setAllowView(true);
        let currData = res?.data?.data?.videosList;
        setDataList(currData);
        setCurrentDataSorted(res?.data?.data?.videosList);
        let vc = 0;
        // eslint-disable-next-line
        res?.data?.data?.videosList.forEach((video) => {
          if (video.isActivated) {
            vc = vc + 1;
          }
        });
        !searchVal && setTotalCount(vc);
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalAlert("error", error?.response?.data?.message);
      if (error?.response?.data?.status === 401) {
        logOut(props?.history, "/admin/login");
      }
      globalLoader(false);
    }
  };
  const closeModalMain = async (val = null) => {
    if (val) {
      globalLoader(true);
      let res;
      if (editDataIs) {
        // res = await editAccessCodeApi(val, currentData?.accessCodeId)
      } else {
        res = await addVideoApi(val);
      }

      if (res?.data?.status === 200) {
        globalAlert("success", res?.data?.message);
        if (editDataIs) {
          setEditDataIs(false);
        } else {
          setSearchVal("");
        }

        setNotFilteredRun(false);
        setCurrentData(null);
        setOpenModal(false);
        callBasicApi();
      } else {
        globalAlert("error", res?.data?.message);
        globalLoader(false);
      }
    } else {
      setEditDataIs(false);
      setCurrentData(null);
      setOpenModal(false);
    }
  };

  const viewVideo = async (data) => {
    globalLoader(true);
    setCurrentVideoSrc(data);
    setOpenVideoModal(true);
    globalLoader(false);
  };

  const editData = (data) => {
    setEditDataIs(true);
    setCurrentData(data);
    setOpenModal(true);
  };

  const toggleData = async (id) => {
    globalLoader(true);
    let res = await toggleVideoApi(id);
    if (res?.data?.status === 200) {
      setNotFilteredRun(false);
      callBasicApi();
    } else {
      globalAlert("error", res?.data?.message);
      globalLoader(false);
    }
  };

  const confirmModalFunc = async (val) => {
    if (val) {
      globalLoader(true);
      let res = await deleteVideoApi(currentUserId);
      if (res?.data?.status === 200) {
        globalAlert("success", res?.data?.message);
        if (totalCount === 1) {
          setSearchVal("");
        }
        setNotFilteredRun(false);
        setCurrentData(null);
        callBasicApi();
      } else {
        globalAlert("error", res?.data?.message);
        globalLoader(false);
      }
    }
    setConfirmaModalOpen(false);
  };

  const deleteData = async (data) => {
    setCurrentUserId(data?.videoId);
    let obj = [
      `Title : ${data?.videoTitle}`,
      `Description : ${data?.videoDescription}`,
    ];
    setDeleteInfo(obj);
    setConfirmaModalOpen(true);
  };

  useEffect(() => {
    if (!notFilteredRun) {
      filteredDataFunc();
    } // eslint-disable-next-line
  }, [pageSize, currentPage, sortObj, currentDataSorted, dataList]);

  const filteredDataFunc = (dataArray = null, localPage = null) => {
    let arr = [...dataList];
    let filterArr = [];
    let filteredData = [];
    if (dataArray) {
      arr = [...dataArray]
    }
    else {
      arr = arraySort(arr, compareValues(sortObj?.sortVal), { reverse: sortObj?.sortType === 'desc' ? true : false });
    }

    if (searchVal.length > 0) {
      filterArr = arr.filter((data) => {
        if (data?.isActivated) {
          if (
            data?.videoTitle.toLowerCase().includes(searchVal.toLowerCase()) ||
            data?.videoDescription
              .toLowerCase()
              .includes(searchVal.toLowerCase())
          ) {
            return data;
          } else {
            return null;
          }
        } else {
          return null;
        }
      });
    } else {
      filterArr = arr;
    }
    if (filterArr && filterArr.length > 0) {
      let vc = 0;
      filterArr.forEach((video) => {
        if (video.isActivated) {
          vc = vc + 1;
        }
      });
      setTotalCount(vc);
      for (
        let i = (localPage || currentPage) * pageSize - pageSize;
        i < (localPage || currentPage) * pageSize && i < filterArr.length;
        i++
      ) {
        filteredData.push(filterArr[i]);
      }
    }
    setCurrentDataList(filteredData);
  };

  const changePageSizeFunc = async (val) => {
    setNotFilteredRun(false);
    setPageSize(val.target.value);
    setCurrentPage(1);
    setSortObj(null);
  };

  const searchFilter = (ev) => {
    ev.preventDefault();
    let arr = [...dataList];
    let filterArr = arr.filter(
      (data) =>
        data?.videoTitle.toLowerCase().includes(searchVal.toLowerCase()) ||
        data?.videoDescription.toLowerCase().includes(searchVal.toLowerCase())
    );
    setTotalCount(filterArr.length);
    setNotFilteredRun(true);
    setCurrentDataList(filterArr);
    setCurrentPage(1);
    setSortObj(null);
  };

  const goToPageFunc = (val, data) => {
    setNotFilteredRun(false);
    if (data === "prev" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else if (
      data === "next" &&
      currentPage < Math.ceil(dataList.length / pageSize)
    ) {
      setCurrentPage(currentPage + 1);
    } else {
      setCurrentPage(val.target.value);
    }
  };

  const arraySorting = (val) => {
    let arr = [...dataList];
    let sortedArr;
    let sortType = "aesc";
    if (val === sortObj?.sortVal && sortObj?.sortType === "aesc") {
      sortType = "desc";
    }
    sortedArr = arraySort(arr, compareValues(val), { reverse: sortType === 'desc' ? true : false })

    setNotFilteredRun(true);

    setCurrentPage(1);
    setSortObj({
      sortVal: val,
      sortType: sortType,
    });
    filteredDataFunc(sortedArr, 1)

  };
  return (
    <>
      <Helmet>
        <title>{t("admin.pageTitle.manageVideos")} - eC-Card</title>
        <meta name="viewport" content="width=1200, initial-scale=1" />
      </Helmet>
      {allowView && (
        <div className="admin-portal">
          <Header roleType="admin" />
          <div className={`${navbarToggle ? "active" : ""} wrapper`}>
            <SidebarComponent
              navbarToggle={navbarToggle}
              active={props.match.path}
            />
            <div className="main">
              <div className="main-wrapper">
                <div>
                  <p className="admin-banner">{t("admin.videos.title")}</p>
                </div>
                <SidebarArrow handleSidebarToggle={handleSidebar} />
                <div>
                  <div className="container-fluid">
                    <div className="row admin-controls">
                      <form
                        onSubmit={searchFilter}
                        className="col-12 col-lg-6 admin-search"
                      >
                        <div className="search-wrapper">
                          <InputComponent
                            placeholder="Search"
                            label={t("admin.videos.searchPlaceholder")}
                            type="text"
                            name="search"
                            theme="admin"
                            value={searchVal}
                            handleCallback={(val) => {
                              setSearchVal(val);
                            }}
                          />
                        </div>
                        <button type="submit" className="btn secondary-btn">
                          {t("common.go")}
                        </button>
                      </form>
                      <div className="col-12 col-lg-6 admin-add-new mt-4 mt-lg-0 d-flex justify-content-start justify-content-lg-end">
                        <button
                          onClick={() => setOpenModal(true)}
                          className="btn secondary-btn modal-btn"
                        >
                          <i className="fas fa-plus"></i> {t("admin.videos.addButton")}
                        </button>
                      </div>
                      {dataList?.length > 0 && (
                        <div
                          className="px-3 col-12 pt-3"
                          style={{ borderTop: "2px solid #ebeef1" }}
                        >
                          <PaginationOwn
                            pageSize={pageSize}
                            changePageSize={changePageSizeFunc}
                            goToPage={goToPageFunc}
                            totalCount={totalCount}
                            currentPage={currentPage}
                            applicationType={
                              currentDataList?.length > 1 ? "videos" : "video"
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {currentDataList?.length > 0 ? (
                  <VideoTable
                    dataList={currentDataList}
                    arraySorting={arraySorting}
                    basicApiCall={callBasicApi}
                    sortObj={sortObj}
                    editData={editData}
                    toggleData={toggleData}
                    deleteData={deleteData}
                    viewVideo={viewVideo}
                  />
                ) : (
                  <div className="px-3 pt-3">
                    <div className="no-data-available">{t("common.noDataAvailable")}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {openModal && (
        <AddVideoModal
          open={openModal}
          closeModal={closeModalMain}
          data={currentData}
          edit={editDataIs}
        />
      )}

      {confirmaModalOpen && (
        <ConfirmationModal
          deleteInfo={deleteInfo}
          open={confirmaModalOpen}
          description={t("admin.videos.confirmDeleteVideo")}
          onCloseModal={confirmModalFunc}
        />
      )}

      {openVideoModal && (
        <VideoModal
          open={openVideoModal}
          closeModal={() => setOpenVideoModal(false)}
          data={currentVideoSrc}
        />
      )}
    </>
  );
};

export default withRouter(ManageVideos);
